var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgNew = function SvgNew(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 12 12"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillOpacity: 0.85,
    d: "m11.305 3.873-3.4-.494L6.384.297a.43.43 0 0 0-.769 0l-1.52 3.082-3.401.494a.428.428 0 0 0-.237.731l2.46 2.399-.581 3.387a.428.428 0 0 0 .621.451L6 9.242l3.041 1.6a.428.428 0 0 0 .621-.451l-.58-3.388 2.46-2.399a.428.428 0 0 0-.237-.731M8.046 6.665l.484 2.817L6 8.153l-2.53 1.33.484-2.816L1.907 4.67l2.829-.411L6 1.698 7.264 4.26l2.829.411z"
  })));
};
export default SvgNew;